// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContactPerson } from './contact-person';

/**
 * 
 * @export
 * @interface ContractorNewEdit
 */
export interface ContractorNewEdit {
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    type: ContractorNewEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNewEdit
     */
    comment?: string;
    /**
     * 
     * @type {ContactPerson}
     * @memberof ContractorNewEdit
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractorNewEdit
     */
    studentIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ContractorNewEditTypeEnum {
    Juridical = 'juridical',
    Physical = 'physical'
}



